import React, {useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {Link, useParams} from "react-router-dom";
import {SetPerformanceMenuDistrictIdAction} from "../../actions/performance_actions";
import {LoadDistrictsAction, filterConstants, CustomDropdown, LoadingAction} from "mindsets-js-sdk";

export default function () {
    const params = useParams();
    const dispatch = useDispatch();
    const me = useSelector(state => state.me);
    const performance_configs = useSelector(state => state.performance_configs);
    const district_id = useSelector(state => state.performance_menu_district_id);
    const districts = useSelector(state => state.districts);
    const district_ids = [...new Set(performance_configs.map(config => config.district_id))];

    function renderOptions() {
        const options = {
            '0': <a onClick={event => {
                event.preventDefault();
                dispatch(SetPerformanceMenuDistrictIdAction(null));
            }}>PLEASE SELECT</a>
        };
        districts.map(district => {
            options[district.id.toString()] = <a onClick={event => {
                event.preventDefault();
                dispatch(SetPerformanceMenuDistrictIdAction(district.id));
            }}>{district.name.toUpperCase()}</a>;
        });

        return options;
    }

    function renderDistrictSelector() {
        if (district_ids.length > 1) {
            return (
                <div>
                    <CustomDropdown
                        trigger={<i className='fas fa-cog'/>}
                        no_wrap={true}
                        items={renderOptions()}
                        disabled={districts.length <= 0}
                        selected={district_id ? district_id.toString() : ''}
                    />
                </div>
            );
        }

        return null;
    }

    function renderMenuOptions() {
        const configs = performance_configs.filter(config => config.district_id === (district_id ? district_id : me.school.district_id));

        return configs.map((config, index) => {
            return (
                <div
                    key={index}
                    className={'performance-dashboard-menu-item ' + (config.slug === params.slug || index === 0 && !params.slug ? 'active' : '')}
                >
                    <Link to={'/performance/' + config.slug}>{config.name}</Link>
                </div>
            );
        })
    }

    useEffect(() => {
        const district_ids = [...new Set(performance_configs.map(config => config.district_id))];
        if (district_ids.length > 1) {
            dispatch(LoadDistrictsAction({'filters[id][0]': filterConstants.EXPRESSION_IN + '=' + district_ids.join(',')})).then(() => dispatch(LoadingAction(true, 'Please wait while we load your Mindsets data!')));
        }
    }, [performance_configs]);

    if (!performance_configs.length) {
        return null;
    }

    return (
        <div className="container">
            <div className="section">
                <div className="performance-dashboard-menu">
                    <div className="flex-row flex-h-between">
                        <div className="flex-row flex-wrap flex-gap-15">
                            {renderMenuOptions()}
                        </div>
                        {renderDistrictSelector()}
                    </div>
                    <div className='divider'/>
                </div>
            </div>
        </div>
    );
}
